import Alpine from 'alpinejs';
import {customCursor} from '@groupthought/analog-ui/alpine';

Alpine.plugin(customCursor);
